import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Error.css';

function Error({ title, message }) {
  const { logout } = useAuth();

  return (
    <div className="error-container">
      <div className="error-card">
        <div className="error-icon">⚠️</div>
        <h1>{title || 'Error'}</h1>
        <p>{message || 'Something went wrong.'}</p>
        <button className="error-btn" onClick={logout}>
          Sign Out
        </button>
      </div>
    </div>
  );
}

export default Error;